<template>
<div v-if="type === 1 || type === 2 || type === 11" class="chat-item">
  <div class="inner-top clearfix">
    <div class="assets-wrap left">
      <img v-lazy="isSupportWebp(data.userAvatar)" width="40" :alt="data.userName" />
    </div>
    <div class="title left">
      <p>
        <span class="ellipsis inline" style="max-width: 120px;"><i class="iconfont icon-sf" :class="`yf-user-type_${data.userType}`" :title="identity(data.userType)"></i>{{ data.userName }}</span>
        <el-tooltip effect="light" v-if="data.userType !== 1 && data.userType !== 9" :content="data.normalLevel | level(true)" placement="bottom">
          <span class="sprite-level" :class="[`level-${data.normalLevel}`]"></span>
        </el-tooltip><span v-if="data.userTags === 7" title="投票达人" class="f"></span>
      </p>
      <p class="time">{{ data.createdAt.substring(5) }}</p>
    </div>
    <div class="action right clearfix" v-if="type !== 11">
      <span class="hover" @click="handleReply(data.id, data.userName)">回复</span>
      <span class="hover" @click="handleQuote" v-if="isRoomTeacher || isRoomGuest">引用</span>
      <span class="more hover" @mouseover="moreflag = true" @mouseleave="moreflag = false" v-if="isRoomManger || isRoomTeacher || isRoomGuest">...</span>
      <div v-show="moreflag" @mouseover="moreflag = true" @mouseleave="moreflag = false" class="more-item" :style="{ left: type === 11 ? '90px' : 0 }">
        <!-- <p>@TA</p>  -->
        <p class="hover" @click="handleRemove">删除</p>
        <p class="hover" @click="handleForbid(data)" v-if="type !== 11">禁言</p>
      </div>
    </div>
  </div>
  <div ref="inner" class="bottom_wrap">
    <!-- 普通聊天 -->
    <div v-if="type === 1" class="normal">
      <p class="rich_text" :class="`yf-text_${fontSize}`" v-html="switchBody(data.content, '!/fw/200')" ></p>
    </div>
    <!-- 回复聊天 -->
    <div v-else-if="type === 2" class="quote" >
       <p class="rich_text" :class="`yf-text_${fontSize}`" v-html="switchBody(data.content, '!/fw/200')"></p>
      <div class="top_wrap">
        <div class="title">
          <p class="left left_p">【原文】<i class="iconfont icon-sf" :title="identity(data.quoteUserType)" :class="`yf-user-type_${data.quoteUserType}`"></i> <span class="ellipsis">{{ data.quoteUserName }}</span></p>
          <p class="right_p">{{ data.quoteCreateAt.slice(5) }} <span @click="handleReply(data.quoteId, data.quoteUserName)">回复</span></p>
        </div>
        <p class="rich_text" :class="`yf-text_${fontSize}`" v-html="switchBody(data.quoteContent, '!/fw/200')"></p>
      </div>
    </div>
  </div>
  <!-- 红包信息 -->
  <div v-if="type === 11" class="redpack-info" :class="{ history: isHistory || redpackStatus }" @click="openRedpack">
    <span>拆</span>
    <p>{{ data.content | redpack(isHistory) }}</p>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { switchBody, identity, level } from '@/utils/Filters'
import Dialog from '@/utils/Dialog'
import Webp from '@/mixins/Webp'

export default {
  mixins: [Webp],
  name: 'component-room-chat',
  data () {
    return {
      moreflag: false
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    fontSize: {
      type: String,
      default: '16'
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.inner) {
        let imgs = this.$refs.inner.querySelectorAll('img')
        for (let img of imgs) {
          // 绑定加载完成事件
          img.onload = () => {
            this.$emit('imgLoad')
          }
          // 绑定图片放大事件
          img.onclick = () => {
            let origin = img.getAttribute('origin');
            if (origin) {
              this.$emit('showImg', origin)
            } else if (!img.classList.contains('js-ubb')) {
              //如果图片不是系统自带表情
              //处理后台客服服务发送图片,自动伸缩
              this.$emit('showImg', img.getAttribute('src'))
            }
          }
        }
      }
    })
  },
  methods: {
    // 拆红包
    openRedpack () {
      if (!this.$isLogin()) {
        Dialog.login()
        return
      }
      // console.log(this.data)
      this.$emit('setRedpackData', null, this.data.id)
      let data = JSON.parse(this.data.content)
      // console.log(this.data)
      data.userAvatar = this.data.userAvatar
      data.userName = this.data.userName
      this.$axios._get('/RedPacket/Info', { id: data.id }).then(res => {
        console.log(res)
        /* 
         * 红包状态：
         * 2 -- 过期
         * 3 -- 没抢过，没抢完
         * 4 -- 没抢过，抢完了
         * 5 -- 抢过
         */
        if (res.status) {
          this.$parent.redpack.status = 2
        } else if (res.isReceived) {
          this.$parent.redpack.status = 5
        } else if (res.isEmpty) {
          this.$parent.redpack.status = 4
        } else {
          this.$parent.redpack.status = 3
        }
        this.$emit('setRedpackData', 0, res)
        this.$emit('setRedpackData', 1, data)
      })
    },
    // 引用
    handleQuote () {
      this.$store.commit('room/setQuote', {
        id: this.data.id,
        username: this.data.userNickName
      })
    },
    // 回复
    handleReply (id, username) {
      this.$store.commit('room/setReply', { id, username })
    },
    // 删除
    handleRemove () {
      Dialog.confirm('您确定要删除该评论吗？').then(() => {
        this.$axios._post('/Room/RemoveComment', { id: this.data.id }).then(res => {
          if (!this.$store.state.room.isWebSocket) {
            this.$store.commit('room/removeComment', res)
          }
        })
      })
    },
    // 禁言
    handleForbid (data) {
      if (this.data.userId === this.$store.state.user.data.id) {
        this.$notify({
          title: '警告',
          message: '不能禁言自己',
          type: 'warning'
        })
        return
      }
      Dialog.confirm(`您确定要禁言【${this.data.userNickName}】这个用户吗？`).then(() => {
        this.$axios._post('/Room/Forbid', {
          id: this.roomData.id,
          user_id: this.data.userId,
          type: 0
        }).then(res => {
          this.$notify.success({
            title: '成功',
            message: '禁言成功'
          })
          let user = {
            id: this.data.userId,
            avatar: this.data.userAvatar,
            userName: this.data.userName,
            type: 0
          }
          this.$store.commit('teacher/addForbidUser', user)
        })
      })
    },
    identity,
    switchBody,
  },
  filters: {
    redpack (v, history) {
      v = JSON.parse(v)
      if (history) {
        return '红包已过期'
      } else if ('title' in v) {
        return v.title
      } else if (v.isEmpty) {
        return '红包已抢光'
      } else if (v.isReceived) {
        return '红包已抢过'
      }
    },
    level
  },
  computed: {
    // 消息类型
    type () {
      switch (this.data.type) {
        case 6:
          return this.data.quoteId > 0 ? 2 : 1
        case 11:
          return 11
        default:
          return 0
      }
    },
    roomData () {
      return this.$store.state.room.data
    },
    ...mapGetters({
      isRoomManger: 'user/isManger',
      isRoomTeacher: 'room/isTeacher',
      isRoomGuest: 'room/isGuest'
    }),
    isHistory () {
      return /history/.test(this.$route.path)
    },
    redpackStatus () {
      let d = JSON.parse(this.data.content)
      return !!d.isReceived || !!d.isEmpty
    }
  }
}
</script>

<style lang="less" scoped>
.chat-item {
  background-color: #fff; border-radius: 4px; box-shadow: 0 1px 2px #ccc; padding: 15px;
  &:not(:last-child) {
    margin-bottom: 20px;
  }
  .inner-top {
    .assets-wrap { width: 45px; height: 40px;
      img { width: 40px; height: 40px; border-radius: 50%;}
    }
    .title { width: 160px; padding-top: 1px;
      > p { color: #666666;}
      > p:nth-child(1) {
        img { vertical-align: middle; margin-right: 10px;}
        .gameflag { vertical-align: middle; margin-right: 10px; margin-left: 10px;}
        span { vertical-align: middle; font-size: 14px; color: #5d99f1; }
        span.sprite-level {
          transform: scale(.7); vertical-align: -48%;
        }
      }
      > p:nth-child(2) { line-height: 20px; color: #999999;}
    }
    .action {
      width: 118px; height: 100%; position: relative; text-align: right;
      > span {
        float: right; padding: 1px 8px; border: 1px solid #ccc; font-size: 12px; color: #999; border-radius: 2px; cursor: pointer;
        &:not(:first-child) {
          margin-right: 3px;
        }
        .iconfont { font-size: 12px; }
      }
      > .more-item { position: absolute; top: 20px; left: 0; width: 54px; z-index: 100;
        p {
          cursor: pointer; border: 1px solid #ccc; padding: 1px 8px; margin: 2px 0; background: #FFFFFF; text-align: center; font-size: 12px; color: #999; border-radius: 2px;
        }
      }
      .hover:hover {
        color: #5c9bea; border-color: #5c9bea;
      }
    }
  }
  .bottom_wrap {
    padding-top: 6px; color: #343434;
    .rich_text {
      line-height: 1.6;
    }
    > .quote {
      .top_wrap { padding: 12px; border-radius: 3px; background-color: #f1f1f7; margin-top: 6px;
        .title { overflow: hidden; margin-bottom: 6px;
          .left_p { font-size: 14px; color: #999;
            .icon-sf {
              vertical-align: -5%;
            }
            span {
              display: inline-block; max-width: 110px; font-size: 14px; color: #5d99f1; vertical-align: -14%; line-height: 1;
            }
          }
          .right_p { display: inline-block;color: #9a9a9a; line-height: 1.8; padding-left: 6px;
            span { color: #5d99f1; cursor: pointer; }
          }
        }
      }
    }
  }
  // 红包icon
  .redpack-info {
    width: 100%; height: 80px; background-color: #d8383b; border-radius: 4px; position: relative; overflow: hidden; cursor: pointer;
    &:before {
      content: " "; display: block; position: absolute; left: -5%; top: -50px; width: 110%; height: 80px; background-color: #ef4b4b; border-radius: 50%;
    }
    span {
      display: block; position: absolute; left: 50%; top: 18%; background: #fccf43; width: 30px; line-height: 30px; text-align: center; color: #e43a3d; font-size: 16px; border-radius: 50%; transform: translateX(-50%);
    }
    p {
      font-size: 16px; color: #fff; text-align: center; margin-top: 45px;
    }
    &.history {
      background-color: lighten(#d8383b, 10%);
      &:before {
        background-color: lighten(#ef4b4b, 10%);
      }
      span {
        background-color: lighten(#fccf43, 15%);
      }
    }
  }
}
</style>
